import { LeadIntention, LeadStatus } from '@euler/model/lead/Lead';
import { ApdmCampaignStatus } from './campaign';
import { ApdmCampaignSummary } from './campaign-api';
import { ApdmReportMetrics } from './reporting';

/** Mirror of backend `kApdmRunningCampaignStatuses`: still sending,
 * waiting for replies, or paused. */
export const kApdmRunningCampaignStatuses: ReadonlySet<ApdmCampaignStatus> =
  new Set([
    ApdmCampaignStatus.Scheduled,
    ApdmCampaignStatus.Reaching,
    ApdmCampaignStatus.Paused,
    ApdmCampaignStatus.Reached,
  ]);

/** Mirror of backend `ApdmDashboardPeriod`. */
export enum ApdmDashboardPeriod {
  Week = '7d',
  Month = '30d',
  All = 'all',
}

export interface ApdmDashboardCampaign {
  summary: ApdmCampaignSummary;
  funnel: ApdmReportMetrics;
  /** Customers a message went out to, whether or not it arrived. */
  attempted: number;
  /** Every lead the campaign opened. */
  leads: number;
  /** Its leads nobody has followed up yet. */
  newLeads: number;
}

export interface ApdmDashboardUndelivered {
  campaignId: string;
  title: string;
  count: number;
}

export interface ApdmDashboardTodo {
  pendingReviews: number;
  unhandledLeads: number;
  undelivered: ApdmDashboardUndelivered[];
  sendingBlocked: boolean;
}

/** Mirror of backend `ApdmDashboardResult`. */
export interface ApdmDashboardResult {
  period: ApdmDashboardPeriod;
  from: string | null;
  to: string;
  scope: 'full' | 'assigned';
  /** Running campaigns, then those ended in the period, latest first. */
  campaigns: ApdmDashboardCampaign[];
  funnel: ApdmReportMetrics;
  leads: number;
  todo: ApdmDashboardTodo;
}

/** Mirror of backend `ApdmCampaignLeadRow`. */
export interface ApdmCampaignLeadRow {
  leadId: string;
  licensePlateNo: string;
  vehicleName: string;
  customerName: string | null;
  status: LeadStatus;
  intention: LeadIntention;
  assigneeName: string;
  createdAt: string;
}

export interface ApdmCampaignLeadsResult {
  rows: ApdmCampaignLeadRow[];
  total: number;
}
